import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './components/loader/loader.component';
import { ScrollTopComponent } from './components/scroll-top/scroll-top.component';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { TitleSectionComponent } from './components/title-section/title-section.component';
import { CheckListComponent } from './components/check-list/check-list.component';
import { ProgressBarRightPercentageComponent } from './components/progress-bar-right-percentage/progress-bar-right-percentage.component';
import { XaminCircleComponent } from './components/xamin-circle/xamin-circle.component';
import { ServicesComponent } from './components/services/services.component';
import { NavTabsComponent } from './components/nav-tabs/nav-tabs.component';
import { PortfolioBoxComponent } from './components/portfolio-box/portfolio-box.component';
import { PortfolioOwlComponent } from './components/portfolio-owl/portfolio-owl.component';
import { ServiceBoxComponent } from './components/service-box/service-box.component';
import { AboutComponent } from './components/about/about.component';
import { CounterComponent } from './components/counter/counter.component';
import { CustomersComponent } from './components/customers/customers.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { BlogCardComponent } from './components/blog-card/blog-card.component';
import { TopBannerComponent } from './components/top-banner/top-banner.component';
import { MasonryPorfolioBoxComponent } from './components/masonry-porfolio-box/masonry-porfolio-box.component';
import { BlogSearchComponent } from './components/blog-search/blog-search.component';
import { BlogSliderComponent } from './components/blog-slider/blog-slider.component';
import { BlogRecentPostComponent } from './components/blog-recent-post/blog-recent-post.component';
import { BlogCategoryComponent } from './components/blog-category/blog-category.component';
import { BlogPaginationComponent } from './components/blog-pagination/blog-pagination.component';
import { TeamComponent } from './components/team/team.component';
import { AboutTwoComponent } from './components/about-two/about-two.component';
import { AboutCardComponent } from './components/about-card/about-card.component';
import { BlogOwlComponent } from './components/blog-owl/blog-owl.component';
import { CardOneComponent } from './components/card-one/card-one.component';
import { ChooseUsComponent } from './components/choose-us/choose-us.component';
import { ProjectPortfolioBoxComponent } from './components/project-portfolio-box/project-portfolio-box.component';
import { ServiceMenuComponent } from './service-menu/service-menu.component';
import { FooterStyle1Component } from './components/footer-style1/footer-style1.component';
import { AnnouncementBarComponent } from './components/announcement-bar/announcement-bar.component';

@NgModule({
  declarations: [
    LoaderComponent,
    ScrollTopComponent,
    FooterComponent,
    HeaderComponent,
    TitleSectionComponent,
    CheckListComponent,
    ProgressBarRightPercentageComponent,
    XaminCircleComponent,
    ServicesComponent,
    NavTabsComponent,
    PortfolioBoxComponent,
    PortfolioOwlComponent,
    ServiceBoxComponent,
    AboutComponent,
    CounterComponent,
    CustomersComponent,
    TestimonialsComponent,
    BlogCardComponent,
    TopBannerComponent,
    MasonryPorfolioBoxComponent,
    BlogSearchComponent,
    BlogSliderComponent,
    BlogRecentPostComponent,
    BlogCategoryComponent,
    BlogPaginationComponent,
    TeamComponent,
    AboutTwoComponent,
    AboutCardComponent,
    BlogOwlComponent,
    CardOneComponent,
    ChooseUsComponent,
    ProjectPortfolioBoxComponent,
    ServiceMenuComponent,
    FooterStyle1Component,
    AnnouncementBarComponent,
  ],
  exports: [
    LoaderComponent,
    ScrollTopComponent,
    FooterComponent,
    HeaderComponent,
    TitleSectionComponent,
    CheckListComponent,
    ProgressBarRightPercentageComponent,
    XaminCircleComponent,
    ServicesComponent,
    ServiceBoxComponent,
    PortfolioBoxComponent,
    PortfolioOwlComponent,
    AboutComponent,
    CounterComponent,
    CustomersComponent,
    TestimonialsComponent,
    BlogCardComponent,
    TopBannerComponent,
    MasonryPorfolioBoxComponent,
    BlogPaginationComponent,
    BlogSearchComponent,
    BlogSliderComponent,
    BlogRecentPostComponent,
    BlogCategoryComponent,
    TeamComponent,
    AboutCardComponent,
    AboutTwoComponent,
    BlogOwlComponent,
    CardOneComponent,
    ChooseUsComponent,
    ProjectPortfolioBoxComponent,
    ServiceMenuComponent,
    FooterStyle1Component,
    AnnouncementBarComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class XaminModule { }
